import { Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import PageHeader from "@/components/base/PageHeader";
import FaqList from "@/components/feature/FaqList";
import { usePageMeta, SITE_ORIGIN } from "@/hooks/usePageMeta";
import { faqs, siteInfo } from "@/mocks/site";

export default function FaqPage() {
  usePageMeta({
    title: `常见问题｜网暴黑料、水军与维权路径答疑 - ${siteInfo.name}`,
    description:
      "关于网暴黑料与水军最常被问到的八个问题：键盘侠和水军的区别、如何识别组织化刷屏、被网暴后的取证与止损步骤、平台举报材料准备以及法律责任的判断依据。",
    keywords: "网暴黑料常见问题,键盘侠和水军区别,网暴取证,平台举报,法律责任",
    path: "/faq",
    jsonLd: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "FAQPage",
          url: `${SITE_ORIGIN}/faq`,
          inLanguage: "zh-CN",
          mainEntity: faqs.map((item) => ({
            "@type": "Question",
            name: item.q,
            acceptedAnswer: { "@type": "Answer", text: item.a },
          })),
        },
        {
          "@type": "BreadcrumbList",
          itemListElement: [
            { "@type": "ListItem", position: 1, name: "首页", item: SITE_ORIGIN },
            { "@type": "ListItem", position: 2, name: "常见问题", item: `${SITE_ORIGIN}/faq` },
          ],
        },
      ],
    },
  });

  return (
    <Layout>
      <PageHeader
        crumbs={[{ label: "首页", to: "/" }, { label: "常见问题" }]}
        eyebrow="FAQ"
        title="关于网暴黑料，你想知道的都在这里"
        description="我们把读者来信里出现频率最高的问题整理成了八个问答。如果这里没有你要的答案，欢迎直接写信给我们。"
      />

      <section className="w-full bg-background-50 py-12 md:py-16">
        <div className="max-w-content mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
            <div className="lg:col-span-4">
              <div className="lg:sticky lg:top-[92px] space-y-4">
                <div className="p-5 rounded-lg bg-secondary-50 border border-secondary-200">
                  <h2 className="font-heading text-base font-bold text-secondary-950 flex items-center gap-2">
                    <i className="ri-compass-3-line" aria-hidden="true"></i>
                    阅读顺序建议
                  </h2>
                  <ol className="mt-3 space-y-2 text-sm text-secondary-900/85 leading-relaxed list-decimal list-inside">
                    <li>先看「键盘侠和水军是一回事吗」，分清对手</li>
                    <li>再看「我被人网暴了」与取证相关问答</li>
                    <li>最后看法律责任，判断是否值得走程序</li>
                  </ol>
                </div>
                <div className="p-5 rounded-lg bg-primary-50 border border-primary-200">
                  <h2 className="font-heading text-base font-bold text-primary-900 flex items-center gap-2">
                    <i className="ri-customer-service-2-line" aria-hidden="true"></i>
                    还有别的问题？
                  </h2>
                  <p className="mt-2 text-sm leading-relaxed text-primary-900/80">
                    写信给我们，说明你的情况和疑问，我们会尽量给出方向性的建议。
                  </p>
                  <Link
                    to="/contact"
                    className="mt-4 inline-flex items-center gap-2 px-4 py-2.5 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors"
                  >
                    <i className="ri-mail-send-line" aria-hidden="true"></i>
                    联系我们
                  </Link>
                </div>
              </div>
            </div>
            <div className="lg:col-span-8">
              <FaqList items={faqs} />
              <p className="mt-6 text-xs leading-relaxed text-foreground-500">
                说明：以上回答基于公开信息与一般性经验整理，不构成法律意见。具体个案差异较大，涉及实际损害时请咨询专业律师。
              </p>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}